module.exports = __webpack_public_path__ + "img/vbm-wht01.34f2b378.png";